'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _DefaultServiceProvider = require('./config/DefaultServiceProvider');

var _DefaultServiceProvider2 = _interopRequireDefault(_DefaultServiceProvider);

var _ConfigFactory = require('./config/ConfigFactory');

var _ConfigFactory2 = _interopRequireDefault(_ConfigFactory);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * do not call `new Maker()` directly; use `Maker.create` instead
 */
var Maker = function () {
  function Maker(preset) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck3.default)(this, Maker);
    var _options$plugins = options.plugins,
        plugins = _options$plugins === undefined ? [] : _options$plugins,
        otherOptions = (0, _objectWithoutProperties3.default)(options, ['plugins']);
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {

      for (var _iterator = (0, _getIterator3.default)(plugins), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _ref = _step.value;

        var _ref2 = (0, _slicedToArray3.default)(_ref, 2);

        var plugin = _ref2[0];
        var pluginOptions = _ref2[1];

        if (plugin.addConfig) {
          mergeOptions(otherOptions, plugin.addConfig(otherOptions, pluginOptions));
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    var config = _ConfigFactory2.default.create(preset, otherOptions, _DefaultServiceProvider.resolver);
    this._container = new _DefaultServiceProvider2.default(config).buildContainer();

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = (0, _getIterator3.default)(plugins), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var pluginTuple = _step2.value;

        var _pluginTuple = (0, _slicedToArray3.default)(pluginTuple, 2),
            _plugin = _pluginTuple[0],
            _pluginOptions = _pluginTuple[1];

        if (typeof _plugin === 'function') {
          _plugin(this, config, _pluginOptions);
        } else if (_plugin.afterCreate) {
          _plugin.afterCreate(this, config, _pluginOptions);
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    if (otherOptions.autoAuthenticate !== false) this.authenticate();

    delegateToServices(this, {
      accounts: ['addAccount', 'currentAccount', 'currentAddress', 'listAccounts', 'useAccount', 'useAccountWithAddress'],
      cdp: ['getCdp', 'openCdp', 'getCdpIds'],
      event: ['on'],
      proxy: ['currentProxy'],
      token: ['getToken']
    });
  }

  (0, _createClass3.default)(Maker, [{
    key: 'authenticate',
    value: function authenticate() {
      if (!this._authenticatedPromise) {
        this._authenticatedPromise = this._container.authenticate();
      }
      return this._authenticatedPromise;
    }

    // skipAuthCheck should only be set if you're sure you don't need the service
    // to be initialized yet, e.g. when setting up a plugin

  }, {
    key: 'service',
    value: function service(_service) {
      var skipAuthCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var skipAuthCheckForServices = ['event'];
      if (!skipAuthCheck && !this._container.isAuthenticated && !skipAuthCheckForServices.includes(_service)) {
        throw new Error('Can\'t use service ' + _service + ' before authenticate() has finished.');
      }
      return this._container.service(_service);
    }
  }]);
  return Maker;
}();

exports.default = Maker;


function delegateToServices(maker, services) {
  var _loop = function _loop(serviceName) {
    var _loop2 = function _loop2(methodName) {
      maker[methodName] = function () {
        var _maker$service;

        return (_maker$service = maker.service(serviceName))[methodName].apply(_maker$service, arguments);
      };
    };

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = (0, _getIterator3.default)(services[serviceName]), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var methodName = _step3.value;

        _loop2(methodName);
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }
  };

  for (var serviceName in services) {
    _loop(serviceName);
  }
}

function mergeOptions(object, source) {
  return (0, _lodash.mergeWith)(object, source, function (objValue, srcValue, key) {
    if (key === 'addContracts') {
      var dupes = (0, _lodash.intersection)((0, _keys2.default)(objValue || {}), (0, _keys2.default)(srcValue)).filter(function (key) {
        return !(0, _lodash.isEqual)(objValue[key], srcValue[key]);
      });

      if (dupes.length > 0) {
        var label = 'Contract' + (dupes.length > 1 ? 's' : '');
        var names = dupes.map(function (d) {
          return '"' + d + '"';
        }).join(', ');
        throw new Error(label + ' ' + names + ' cannot be defined more than once');
      }
    }

    if (Array.isArray(objValue)) return objValue.concat(srcValue);

    // when this function returns undefined, mergeWith falls back to the
    // default merging behavior.
    // https://devdocs.io/lodash~4/index#mergeWith
  });
}

Maker.create = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var preset, _args$, options, plugins, pluginTuples, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, _ref4, _ref5, plugin, pluginOptions, resultOptions, maker;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            preset = args[0], _args$ = args[1], options = _args$ === undefined ? {} : _args$;
            plugins = options.plugins;

            if (!plugins) {
              _context.next = 37;
              break;
            }

            // If its not already, format the plugin to be a tuple
            // of type [plugin, options object].
            pluginTuples = plugins.map(function (plugin) {
              return !Array.isArray(plugin) ? [plugin, {}] : plugin;
            });
            _iteratorNormalCompletion4 = true;
            _didIteratorError4 = false;
            _iteratorError4 = undefined;
            _context.prev = 7;
            _iterator4 = (0, _getIterator3.default)(pluginTuples);

          case 9:
            if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
              _context.next = 22;
              break;
            }

            _ref4 = _step4.value;
            _ref5 = (0, _slicedToArray3.default)(_ref4, 2);
            plugin = _ref5[0];
            pluginOptions = _ref5[1];

            if (!plugin.beforeCreate) {
              _context.next = 19;
              break;
            }

            _context.next = 17;
            return plugin.beforeCreate(pluginOptions);

          case 17:
            resultOptions = _context.sent;

            (0, _assign2.default)(options, resultOptions);

          case 19:
            _iteratorNormalCompletion4 = true;
            _context.next = 9;
            break;

          case 22:
            _context.next = 28;
            break;

          case 24:
            _context.prev = 24;
            _context.t0 = _context['catch'](7);
            _didIteratorError4 = true;
            _iteratorError4 = _context.t0;

          case 28:
            _context.prev = 28;
            _context.prev = 29;

            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }

          case 31:
            _context.prev = 31;

            if (!_didIteratorError4) {
              _context.next = 34;
              break;
            }

            throw _iteratorError4;

          case 34:
            return _context.finish(31);

          case 35:
            return _context.finish(28);

          case 36:
            // reassign the plugins array in the options
            options.plugins = pluginTuples;

          case 37:
            maker = new Maker(preset, options);

            if (!(options.autoAuthenticate !== false)) {
              _context.next = 41;
              break;
            }

            _context.next = 41;
            return maker.authenticate();

          case 41:
            return _context.abrupt('return', maker);

          case 42:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[7, 24, 28, 36], [29,, 31, 35]]);
  }));

  return function () {
    return _ref3.apply(this, arguments);
  };
}();